export default "__VITE_ASSET__C5EbVfN3__"